const initialState = {
  memberships: null,
  currentMembership: null,
  isUpdate: false,
};

const membershipsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "EDIT_MEMBERSHIP": {
      return {
        ...state,
        currentMembership: { ...state.currentMembership, ...action.data },
      };
    }
    case "FETCH_MEMBERSHIPS":
      return {
        ...state,
        memberships: action.data,
      };

    case "CREATE_MEMBERSHIP": {
      let dt = state.memberships.concat(action.data);
      return {
        ...state,
        memberships: dt,
      }
    };
    case "UPDATE_MEMBERSHIP": {
      let newMessaaging = [...state.memberships];
      const currentMembership = action.data;

      newMessaaging = state.memberships.map((msg) => {
        if (msg._id === currentMembership._id) {
          msg = currentMembership;
        }
        return msg;
      });

      return { ...state, memberships: newMessaaging };
    };
    case "CLEAR_MEMBERSHIP": {
      return {
        ...state,
        currentMembership: null,
      };
    }
    case "DELETE_MEMBERSHIP": {
      let newState = [...state.memberships]
      newState = newState.filter(a => a._id !== action.data)

      return {
        ...state,
        memberships: newState,
      };
    }
    default:
      return state;
  }
};

export default membershipsReducer;
